<template>
  <div class="wf-bg-gray-300">
    <slot></slot>
  </div>
</template>

<script>
  export default {
  }
</script>
